import styled from 'styled-components';
import { CaptionBoldL } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const ResourceTableCont = styled.section`
  width: 1160px;
  position: relative;
  flex-direction: column;
`;

export const ResourceTitle = styled(CaptionBoldL)`
  display: flex;
  text-transform: uppercase;
  ${({ theme }: IThemeProvider) => `
       margin: ${theme.layout.spacing.decy} 0 ${theme.layout.spacing.centy} 0;
       color: ${theme.colors.neutral.primary[80]}
  `};
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  border-radius: 8px;
  ${({ theme }: IThemeProvider) => `
       padding: ${theme.layout.spacing.centy};
       background: ${theme.colors.neutral.primary[5]};
  `};
`;

export const ResourceTableHeader = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  ${({ theme }: IThemeProvider) => `
    border-bottom:1px solid ${theme.colors.neutral.primary[30]};
    margin: 0 0 ${theme.layout.spacing.centy} 0;
  `}
`;

export const TableTitle = styled(ResourceTitle)`
  padding: 0 0 0 48px;
`;

export const TableFooter = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
